import LineChart from "common/Charts/LineChart/LineChart";
import React, { memo, useState } from "react";
import { TimeRange } from "types";
import ChartTimeRangeButtons from "Global/ChartTimeRangeButtons";
import { useSelector } from "react-redux";
import { selectDisplayCurrency } from "@shared/slices/common.slice";
import styled, { useTheme } from "styled-components";
import ArrowsAltOutlined from "@ant-design/icons/ArrowsAltOutlined";
import TimeRangeButton from "common/Buttons/TimeRangeButton";
import { FormattedChartDataPoint } from "@shared/types";

interface AccountCardChartProps {
  graphData: FormattedChartDataPoint[];
  loading: boolean;
  selectedTimeRange: TimeRange;
  precision: number;
  setSelectedTimeRange?: (timeRange: TimeRange) => void;
  timeRanges?: TimeRange[];
  annotations?: any;
  useExtendToAnnotations?: boolean;
  hideTimeRanges?: boolean;
  numOfXTicks?: number;
  height?: number;
  isSuccess: boolean;
}

const CardChart = ({
  graphData,
  loading,
  selectedTimeRange,
  precision,
  setSelectedTimeRange,
  timeRanges,
  annotations,
  useExtendToAnnotations,
  hideTimeRanges,
  numOfXTicks,
  height,
  isSuccess,
}: AccountCardChartProps) => {
  const appTheme = useTheme();
  const displayCurrency = useSelector(selectDisplayCurrency);
  const [extendToAnnotations, setExtendToAnnotations] = useState(
    useExtendToAnnotations
  );

  return (
    <>
      <LineChart
        data={graphData}
        annotations={annotations}
        extendToAnnotations={extendToAnnotations}
        displayCurrency={displayCurrency}
        style={{ position: "relative", height }}
        loading={loading}
        loadingProps={{
          backgroundColor: appTheme.colors.cardBgColor,
          overlayOpacity: 0.8,
          animate: false,
          hideContentWhileLoading: true,
        }}
        precision={precision}
        numOfXTicks={numOfXTicks}
        height={height}
        isSuccess={isSuccess}
        isSmallChart={true}
        isWebsocket={true}
      />
      {!hideTimeRanges && (
        <TimeRangeWrapper>
          <ChartTimeRangeButtons
            selectedTimeRange={selectedTimeRange}
            handleSelectTimeRange={(timeRange: string) => {
              setSelectedTimeRange?.(timeRange);
            }}
            timeRanges={timeRanges}
            buttonSize={"medium"}
            buttonType={"default"}
            additionalButtons={
              useExtendToAnnotations ? (
                <TimeRangeButton
                  onClick={() => setExtendToAnnotations(!extendToAnnotations)}
                  type="primary"
                  selected={extendToAnnotations}
                  icon={<ArrowsAltOutlined />}
                />
              ) : undefined
            }
          />
        </TimeRangeWrapper>
      )}
    </>
  );
};

const MemoizedCardChart = memo(CardChart);
export default MemoizedCardChart;

const TimeRangeWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-top: 8px;
`;
